import { Badge, Dropdown, Flex, Space, Tag, Tooltip, Typography } from "antd"
import dayjs from "dayjs"
import utc from "dayjs/plugin/utc"

import ButtonComponent from "../../../../../Components/Button"
import { titleSortFilters } from "../../../../../Components/titleSortFilters"
import Icon from "../../../../../Icon"
import { alertsColumnIconMap } from "../../../../../Utils/utils"
import { formatErrorRate, getEndpointStatusView } from "../../utils"

const { Text } = Typography

dayjs.extend(utc)

export const defaultColumns = [
  { field_id: "callback_url", label: "Endpoint", active: true },
  { field_id: "event_type", label: "Type", active: true },
  { field_id: "error_rate", label: "Error rate", active: true },
  { field_id: "status", label: "Status", active: true }
]

export const getColumns = ({ theme }) => ({
  status: {
    key: "status",
    sorter: true,
    title: (state) =>
      titleSortFilters({
        title: "Status",
        sorter: true,
        stateData: state,
        key: "status"
      }),
    dataIndex: "status",
    fixed: "left",
    // width: 120,
    render: (_, record) => {
      const statusView = getEndpointStatusView({ status: _, error_rate: record?.error_rate })

      return (
        <Tag color={statusView.tagColor} key={_} style={{ margin: 0 }} className={"simple large"}>
          <Space>
            <Badge status={statusView.badgeStatus} color={statusView.badgeColor} />
            <Text>{statusView.text}</Text>
          </Space>
        </Tag>
      )
    }
  },
  callback_url: {
    key: "callback_url",
    sorter: true,
    title: (state) =>
      titleSortFilters({
        title: "Endpoint",
        sorter: true,
        stateData: state,
        key: "callback_url"
      }),
    dataIndex: "callback_url",
    // width: 128,
    render: (value, record) => <Text>{`${value}`}</Text>
  },
  error_rate: {
    key: "error_rate",
    sorter: true,
    title: (state) =>
      titleSortFilters({
        title: "Error rate",
        sorter: true,
        stateData: state,
        key: "error_rate"
      }),
    dataIndex: "error_rate",
    // width: 140,
    render: (_) => <Text>{formatErrorRate(_)}</Text>
  },
  event_type: {
    key: "event_type",
    sorter: true,
    title: (state) =>
      titleSortFilters({
        title: "Event Type",
        sorter: true,
        stateData: state,
        key: "event_types",
        justify: "center"
      }),
    dataIndex: "event_types",
    align: "center",
    // width: 132,
    render: (event_types_arr, record) => {
      if (event_types_arr?.length < 3) {
        return (
          <Flex vertical>
            {event_types_arr?.map((el) => (
              <Text>{el?.event_type_display}</Text>
            ))}
          </Flex>
        )
      } else {
        const firstTwoTypes = event_types_arr.slice(0, 2)
        const remainingTypes = event_types_arr.slice(2)
        return (
          <Flex vertical gap={4}>
            {firstTwoTypes.map((type, index) => (
              <Text key={index}>{type?.event_type_display}</Text>
            ))}
            <Dropdown
              menu={{
                items: remainingTypes.map((type, index) => ({
                  key: index,
                  label: type?.event_type_display
                }))
              }}
              placement="bottomLeft"
              trigger={["click"]}
            >
              <ButtonComponent
                type="text"
                size="small"
                icon={<Icon type="arrow_select_down" />}
                style={{
                  padding: "0 4px",
                  height: "auto",
                  fontSize: "12px",
                  width: "fit-content"
                }}
                onClick={(e) => e.stopPropagation()}
              >
                +{remainingTypes.length} more
              </ButtonComponent>
            </Dropdown>
          </Flex>
        )
      }
    }
  }
})

export const getDefaultColumn = ({ field_id, label }) => ({
  key: field_id,
  sorter: true,
  title: (state) =>
    titleSortFilters({
      title: label,
      sorter: true,
      icon: alertsColumnIconMap[field_id],
      stateData: state,
      key: field_id
    }),
  dataIndex: field_id,
  width: 185,
  ellipsis: true,
  render: (_) => _ || "—"
})

export const getActionColumn = ({ onSelectRow }) => {
  const handleAction = (e, data, type) => {
    e.preventDefault()
    e.stopPropagation()
    onSelectRow(data, type)
  }
  return {
    key: "actions",
    title: "",
    width: 70,
    render: (_, record) => (
      <Flex>
        <Tooltip title="Add event">
          <ButtonComponent
            type="link"
            icon={<Icon type={"plus"} />}
            onClick={(e) => handleAction(e, record, "add_event")}
            className="flex center "
          />
        </Tooltip>
      </Flex>
    )
  }
}
